import { useRef, useState } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import ReportContent from "./ReportContent";
import { transformCandidateData, calculatePsychologicalIndicators } from "../utils/reportCalculations";
import { PDF_STYLES } from "../utils/pdfConfig";

const ReportViewer = ({ 
  selectedCandidate, 
  valuesTestData, 
  songTestData, 
  drawingTestData,
  onBackToList, 
  onDownloadPDF 
}) => {
  const componentRef = useRef();
  const [observacionesFinales, setObservacionesFinales] = useState('');

  // Transformar datos del candidato
  const candidatoData = transformCandidateData(selectedCandidate);
  
  // Calcular indicadores psicológicos
  const psychIndicators = calculatePsychologicalIndicators(valuesTestData);

  const handleDownloadPDF = () => {
    onDownloadPDF(componentRef);
  };

  return (
    <Grid container spacing={6}>
      <Grid item xs={12}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <MDBox display="flex" alignItems="center">
              <MDButton
                variant="text"
                color="white"
                size="small"
                onClick={onBackToList}
                sx={{ mr: 2 }}
              >
                <Icon>arrow_back</Icon>&nbsp;Volver a Lista
              </MDButton>
              <MDTypography variant="h6" color="white">
                Informe Psicológico Integral - {candidatoData.nombreCompleto}
              </MDTypography>
            </MDBox>
            
            <MDButton
              variant="gradient"
              color="error"
              size="small"
              onClick={handleDownloadPDF}
            >
              <Icon>picture_as_pdf</Icon>&nbsp;Descargar
            </MDButton>
          </MDBox>
          
          <MDBox p={2} sx={PDF_STYLES.reportContainer}>
            <div ref={componentRef}>
              <ReportContent
                candidatoData={candidatoData}
                valuesTestData={valuesTestData}
                songTestData={songTestData}
                drawingTestData={drawingTestData}
                psychIndicators={psychIndicators}
                observacionesFinales={observacionesFinales}
                onObservacionesFinalesChange={setObservacionesFinales}
              />
            </div>
          </MDBox>
        </Card>
      </Grid>
    </Grid>
  );
};

ReportViewer.propTypes = {
  selectedCandidate: PropTypes.object.isRequired,
  valuesTestData: PropTypes.object,
  songTestData: PropTypes.object,
  drawingTestData: PropTypes.object,
  onBackToList: PropTypes.func.isRequired,
  onDownloadPDF: PropTypes.func.isRequired
};

export default ReportViewer;